import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=dbbee9d0&scoped=true&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaComponent.vue?vue&type=style&index=0&id=dbbee9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbee9d0",
  null
  
)

export default component.exports